module.exports = __webpack_public_path__ + "img/slider_manipulating-cookies.b7558a0a.png";